import { useOutletContext } from 'react-router';

import { PaymentsTable } from '~domains/transactions/widgets/payments-table';

type TransactionsOutletContext = {
  headerSlot: HTMLElement | null;
};

export const PaymentsPage = () => {
  const { headerSlot } = useOutletContext<TransactionsOutletContext>();

  return <PaymentsTable headerSlot={headerSlot} />;
};
